import React from 'react'
import { Container, Title } from '../styled/index'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    console.log(error)
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Title>Error, please reload page</Title>
        </Container>
      )
    }

    return this.props.children
  }
}
